import moment from "moment";
import React from "react";
import { Field } from "formik";
import { connect } from "react-redux";
import { DatePicker } from "components/inputs";
import * as Yup from "yup";
import { isEmpty } from "lodash";
import Form from "components/form";
import { onSaveOrUpdateReportBack } from "app/main/applications/actions/applications.actions";

const dueDate = "Due Date";

const schema = Yup.object().shape({
  reportBack: Yup.object().shape({
    dueDate: Yup.date()
      .default(() => moment().format("YYYY-MM-DD"))
      .required(`${dueDate} is required`)
      .nullable(),
  }),
});

class ReportBackForm extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit = ({ reportBack }, { setErrors }) => {
    const { applicationId, orgUnitId } = this.props;

    this.props.onSaveOrUpdateReportBack(applicationId, orgUnitId, reportBack).then(response => {
      if (response.error !== true) {
        this.props.onSucceed();
      } else {
        setErrors(response.payload);
      }
    });
  };

  render() {
    const { initialValues, ...other } = this.props;

    return (
      <Form
        initialValues={initialValues}
        onSubmit={this.handleSubmit}
        contentProps={other}
        validationSchema={schema}
        content={() => (
          <>
            <Field
              name="reportBack.dueDate"
              component={DatePicker}
              label={dueDate}
              required
            />
          </>
        )}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { reportBack: currentReportBack, id } = ownProps;
  let { reportBack } = schema.cast();

  if (!isEmpty(currentReportBack)) {
    reportBack = {
      ...currentReportBack,
    };
  }
  return ({
    initialValues: { reportBack },
    applicationId: id,
  });
};

export default connect(mapStateToProps, { onSaveOrUpdateReportBack })(ReportBackForm);
